import IEnvCredential from "@/module/main/model/applicationForm/IEnvCredential";
import Brand from "@/module/main/model/applicationForm/BrandEnum";
import TemplateOptions from "@/module/main/page/TemplateOptionsEnum";

export default class EnvCredential implements IEnvCredential {
    constructor(
        public brand: Brand,
        public template: TemplateOptions,
        public username: string,
        public password: string,
    ) {
    }
}
